import Vue from 'vue'
import LhFormatCurrency from '~utils/lh-format-currency'

export default () => {
  Vue.filter('lhFormatCurrency', (amount: number, currency: string, market: string): string => {
    if (typeof (amount) !== 'undefined' && typeof (currency) !== 'undefined') {
      return LhFormatCurrency.formatCents(amount, currency, market)
    }
    return ''
  })
}
